<template>
<b-row>
   <b-navbar fixed=top toggleable="lg">
     <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
     <b-collapse id="nav-collapse" is-nav>
       <b-nav class="justify-content-center mx-auto w-100">
          <b-nav-item to='/'>Home</b-nav-item>
          <b-nav-item to='/about'>About</b-nav-item>
        </b-nav>
      </b-collapse>
   </b-navbar>
</b-row>
</template>

<script>
export default {
  name: 'MenuBar',
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Inconsolata&display=swap');
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
.navbar {
  background-color: white;

}

.navbar a {
  color: black;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}

.navbar a:hover {
  color: hotpink;
}
</style>
